import React from 'react';
import pearClient from 'apis/pearClient';
import { iframePostMessage } from 'utils/constants';
import { sessionGet, SessionKeys } from 'utils/tokenStorage';
import ErrorInterceptor from 'components/common/ErrorInterceptor';
import styles from './styles.module.scss';

export interface IProps {
  item: {
    type: string;
    title: string;
    url: string;
    urlSpanish?: string;
  };
  history: { push: (url: string) => void };
  program: string;
  text?: string;
  locale: string;
}

const ViewLink = ({ item, program, text = 'View', locale }: IProps) => {
  const handleProgramDocument = async (item: {
    type: string;
    title: string;
    url: string;
  }) => {
    const modifiedItem = { ...item, url: `${item.url}?locale=${locale}` };

    try {
      await pearClient.v2.tracking.trackDownloadDocumentEvent(item.title);
    } catch (e) {
      ErrorInterceptor.error(e);
    }

    if (window && window.parent) {
      window.parent.postMessage(
        {
          payload: {
            ...modifiedItem,
            program,
            action: iframePostMessage.LOADED,
          },
        },
        sessionGet(SessionKeys.ORIGIN)!,
      );
    }
  };

  if (item.type === 'link') {
    const href = locale === 'es' ? item.urlSpanish : item.url;
    return (
      <a
        target="_blank"
        data-testid="document-link"
        rel="noopener noreferrer"
        className={styles.link}
        href={`${href}`}
        onClick={() =>
          pearClient.v2.tracking.trackDownloadDocumentEvent(item.title)
        }
      >
        {text}
      </a>
    );
  }

  return (
    <div
      data-testid="document-route"
      className={styles.link}
      onClick={() => handleProgramDocument(item)}
    >
      {text}
    </div>
  );
};

export default ViewLink;
